import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { Pin, ThreeDots } from "react-bootstrap-icons";
import { ApiConnectionString } from "../../constants/ApiConntection";
import axios from "axios";

import LoadingSpinner from "../../components/LoadingSpinner";
import ReportPostModal from "./Modals/ReportPostModal";
import noPostsIllustration from "../../assets/noPostsIllustration.png"

import LightGallery from "lightgallery/react";
// import lgThumbnail from "lightgallery/plugins/thumbnail";
// import lgZoom from "lightgallery/plugins/zoom";
import "lightgallery/css/lightgallery.css";
import { LightGalleryKeyString } from "../../constants/LightGalleryKey";
// import "lightgallery/css/lg-thumbnail.css";
// import "lightgallery/css/lg-zoom.css";

export default function Posts({ id }) {
  const [pinnedClubPost, setPinnedClubPost] = useState(null);
  const [selectedPost, setSelectedPost] = useState(null);
  const [reportPostModal, setReportPostModal] = useState(false);
  const [noMorePosts, setNoMorePosts] = useState(false);
  const [clubPosts, setClubPosts] = useState([]);
  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(10);

  const [isLoading, setIsLoading] = useState(true);

  const cancelModal = () => {
    setReportPostModal(false);
  };

  const ViewMorePosts = async () => {
    // Update skip and take
    const newSkip = skip + 10;
    // const newTake = take + 10;

    // Fetch new posts
    const clubPostsResponse = await axios.get(
      `${ApiConnectionString}/api/ClubPosts?Skip=${newSkip}&Take=10&ClubId=${id}`
    );

    if (clubPostsResponse.data.length == 0) {
      setNoMorePosts(true);
    }

    // Append new posts to the existing ones
    setClubPosts((prevPosts) => [...prevPosts, ...clubPostsResponse.data]);

    // Update state variables for skip and take
    setSkip(newSkip);
    // setTake(newTake);
  };

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const pinnedClubPostResponse = await axios.get(
        `${ApiConnectionString}/api/ClubPost/pin/${id}`
      );
      setPinnedClubPost(pinnedClubPostResponse.data);

      const clubPostsResponse = await axios.get(
        `${ApiConnectionString}/api/ClubPosts?Skip=0&Take=10&ClubId=${id}`
      );
      setClubPosts(clubPostsResponse.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const getWeekDates = (currentDate) => {
      const monday = new Date(currentDate);
      const day = monday.getDay();
      const diffToMonday = (day === 0 ? -6 : 1) - day; // Adjust if the current day is Sunday
      monday.setDate(monday.getDate() + diffToMonday);

      return Array.from({ length: 7 }, (_, i) => {
        const date = new Date(monday);
        date.setDate(monday.getDate() + i);
        return date.toLocaleDateString();
      });
    };

    fetchData();
  }, [id]);

  if (isLoading) {
    return <LoadingSpinner />;
  } else {
    if (clubPosts.length > 0) {
      return (
        <div className="mt-3">
          <div className="">
            <div className="customNav rounded">
              <p className="p-2 fw-bold">Posts</p>
            </div>

            {pinnedClubPost && (
              <div>
                <div className="">
                  <Pin size={20} />
                  <div className="d-flex justify-content-between">
                    <p className="mb-0 fw-bold fontSize20">
                      {pinnedClubPost.title}
                    </p>
                    <Dropdown className="mx-2">
                      <Dropdown.Toggle
                        as="span"
                        id="dropdown-custom-components"
                        className="dropdown-toggle-custom"
                      >
                        <ThreeDots
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setSelectedPost(pinnedClubPost);
                          }}
                        />
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item
                          onClick={() => {
                            setReportPostModal(true);
                          }}
                        >
                          Report
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  {pinnedClubPost.createdDate && (
                    <p className="text-muted mt-0">
                      {pinnedClubPost.createdDate.substring(0, 10)}
                    </p>
                  )}

                  <p>{pinnedClubPost.content}</p>

                  {pinnedClubPost.viewImages.length > 0 && (
                    <LightGallery
                      licenseKey={LightGalleryKeyString}
                      elementClassNames="d-flex"
                    >
                      {pinnedClubPost.viewImages.map((image, index) => {
                        const isVisible = index < 3;
                        const showOverlay =
                          index === 2 && pinnedClubPost.viewImages.length > 3;

                        return (
                          <a
                            href={`${ApiConnectionString}/api/image/${image.id}`}
                            key={image.id}
                            className={`post-image-container image-container pointer ${
                              showOverlay ? "with-overlay" : ""
                            }`}
                            style={{ display: isVisible ? "block" : "none" }}
                          >
                            {isVisible && (
                              <>
                                <img
                                  className="post-image"
                                  src={`${ApiConnectionString}/api/image/${image.id}`}
                                  alt={`Image ${image.id}`}
                                />
                                {showOverlay && (
                                  <div className="post-overlay">
                                    +{pinnedClubPost.viewImages.length - 3}
                                  </div>
                                )}
                              </>
                            )}
                          </a>
                        );
                      })}
                    </LightGallery>
                  )}
                </div>
              </div>
            )}

            {/* Scrollable posts section */}
            <div className="scrollable-posts">
              {!clubPosts.length == 0 ? (
                <>
                  {clubPosts
                    .slice()
                    .sort(
                      (a, b) =>
                        new Date(b.createdDate) - new Date(a.createdDate)
                    )
                    .map((post) => (
                      <div key={post.id} className="">
                        <div className="d-flex justify-content-between">
                          <p className="mb-0 fw-bold fontSize20">
                            {post.title}
                          </p>
                          <Dropdown className="mx-2">
                            <Dropdown.Toggle
                              as="span"
                              id="dropdown-custom-components"
                              className="dropdown-toggle-custom"
                            >
                              <ThreeDots
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  setSelectedPost(post);
                                }}
                              />
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() => {
                                  setReportPostModal(true);
                                }}
                              >
                                Report
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                        {post.createdDate && (
                          <p className="text-muted mt-0">
                            {post.createdDate.substring(0, 10)}
                          </p>
                        )}

                        <p>{post.content}</p>

                        {post.viewImages.length > 0 && (
                          <LightGallery
                            licenseKey={LightGalleryKeyString}
                            elementClassNames="d-flex"
                          >
                            {post.viewImages.map((image, index) => {
                              const isVisible = index < 3;
                              const showOverlay =
                                index === 2 && post.viewImages.length > 3;

                              return (
                                <a
                                  href={`${ApiConnectionString}/api/image/${image.id}`}
                                  key={image.id}
                                  className={`post-image-container image-container pointer ${
                                    showOverlay ? "with-overlay" : ""
                                  }`}
                                  style={{
                                    display: isVisible ? "block" : "none",
                                  }}
                                >
                                  {isVisible && (
                                    <>
                                      <img
                                        className="post-image"
                                        src={`${ApiConnectionString}/api/image/${image.id}`}
                                        alt={`Image ${image.id}`}
                                      />
                                      {showOverlay && (
                                        <div className="post-overlay">
                                          +{post.viewImages.length - 3}
                                        </div>
                                      )}
                                    </>
                                  )}
                                </a>
                              );
                            })}
                          </LightGallery>
                        )}
                      </div>
                    ))}
                  {!noMorePosts ? (
                    <button
                      className="booked-button p-1 fw-bold mt-1"
                      onClick={ViewMorePosts}
                      disabled={noMorePosts}
                    >
                      View more
                    </button>
                  ) : (
                    <p className="text-muted">No more posts</p>
                  )}
                </>
              ) : (
                <div>
                  <p>No posts</p>
                </div>
              )}
            </div>

            {reportPostModal && (
              <ReportPostModal post={selectedPost} cancelModal={cancelModal} />
            )}
          </div>
        </div>
      );
    }else{
     return(
  <div className="d-flex flex-column align-items-center mt-4">
    <img 
      src={noPostsIllustration} 
      alt="No posts" 
      className="mb-0 img-fluid pb-0"
    />
    <p className="text muted fs fs4 p-0">No posts</p>
  </div>
)
    }
  }
}
